export const resumeData = [
  {
    key: "1",
    Name: "work history",
    data: [
      {
        job: "VMD Corp",
        jobDates: "November 2023 - Present  |  Remote",
        jobTitle: "UX UI Designer",
        jobTask: (
          <ul>
            <li>
              Created a design system and user interface guideline documents to
              enhance development speed and ensure cohesion across all
              applications at the National Science Foundation.
            </li>
            <li>
              Collaborated with the Power Apps development team to streamline
              the app development process, from stakeholder meetings to final
              design handoffs and post-development design reviews.
            </li>
            <li>
              Led all design for an application to identify and mitigate pain
              points at international airports, such as backed-up security lines
              and baggage claim issues. The results from this project led to a
              large increase in profits and future work for VMD.
            </li>
          </ul>
        ),
      },
      {
        job: "FinTron",
        jobDates: "January 2023 - June 2023  |  Remote",
        jobTitle:
          "UX UI Designer / Senior Front End Developer / Project Management",
        jobTask: (
          <ul>
            <li>
              Designed and developed new components for an SDK to facilitate the
              licensing of key features of our flagship app, resulting in
              increased revenue and expanded customer reach.
            </li>
            <li>
              Built a new dashboard for user automated investments, enabling
              customers to easily manage and monitor their portfolios and
              investments.
            </li>
            <li>
              Led the migration of the API to gRPC and GraphQL, resulting in
              improved performance, reliability, and flexibility.
            </li>
            <li>
              Collaborated closely with the design team to create intuitive and
              visually appealing screens for stock and crypto trades, enhancing
              the user experience and driving engagement.
            </li>
            <li>
              Managed multiple cross-functional teams in developing and
              delivering projects on time and within budget, utilizing Agile
              methodologies and project management tools.
            </li>
          </ul>
        ),
      },
      {
        job: "Ramsey Development",
        jobDates: "January 2019 - Present | Remote",
        jobTitle: "Owner / Designer / Developer",
        jobTask: (
          <ul>
            <li>
              Established and managed a successful full-service graphic and web
              design business since 2019, providing clients with a range of
              services from logo design to web app development.
            </li>
            <li>
              Built design systems, brand guidelines, and reusable components
              for multiple corporations.
            </li>
            <li>
              Emphasized a clean UX design approach and prioritized user flow
              and intuition.
            </li>
            <li>
              Cultivated strong client relationships by providing exceptional
              customer service and maintaining open communication channels to
              ensure their needs are met.
            </li>
          </ul>
        ),
      },
      {
        job: "iFit",
        jobDates: "September 2017 - November 2022 | Remote",
        jobTitle: "Front End Developer",
        jobTask: (
          <ul>
            <li>
              Contributed as a senior member of iFit's Front End Development
              Team, adeptly crafting reusable functional components utilizing
              React TypeScript.
            </li>
            <li>
              Oversaw the design, development, and upkeep of the customer facing
              website, user onboarding flow, membership renewal flow, and
              post-login dashboard.
            </li>
            <li>
              Prioritized ADA compliance and user-centric design throughout all
              projects.
            </li>
          </ul>
        ),
      },
      {
        job: "WeGoLook",
        jobDates: "January 2016 - September 2017 | Oklahoma City, OK",
        jobTitle: "UX UI Designer / Front End Developer",
        jobTask: (
          <ul>
            <li>
              Led a complete full-scale website redesign and development, as
              well as the complete redesign of the company's new app, which
              currently serves over 40K users.
            </li>
            <li>
              Managed day-to-day operations, offering clear product direction
              for the mobile app's development.
            </li>
            <li>
              Implemented a new A/B landing page test setup and tended to the
              company's SEO needs to improve website traffic and user
              engagement.
            </li>
          </ul>
        ),
      },
      {
        job: "Narrate",
        jobDates: "January 2011 - January 2016 | Hybrid",
        jobTitle: "Product Designer",
        jobTask: (
          <ul>
            <li>
              Worked alongside designers, developers, and clients to align
              design strategies with marketing goals.
            </li>
            <li>
              Created user-focused designs for effective marketing campaigns
              that boosted brand awareness and conversions.
            </li>
            <li>
              Used data and user insights to refine designs, leading to
              consistently successful campaigns.
            </li>
          </ul>
        ),
      },
    ],
  },
  {
    key: "2",
    Name: "education",
    data: [
      {
        college: "Art Institute of Dallas",
        degree: "Associates in Multimedia Design",
        whenWhere: "October 2003 - May 2006 |  Dallas, Texas",
        summary:
          "I completed coursework in a range of graphic design and animation topics with a primary focus on web design and development. Through this program, I acquired skills in areas such as user interface design, HTML/CSS coding, responsive design, and content management systems. Additionally, I had the opportunity to participate in hands-on projects that involved creating and launching websites, designing and prototyping user interfaces, and developing multimedia content. These experiences allowed me to hone my skills and apply them in practical ways.",
      },
    ],
  },
  {
    key: "3",
    Name: "references",
    data: [
      {
        name: "Zack Laird",
        referenceJob: "ESG & Supply Chain",
        company: "Flywheel Energy, LLC",
        phone: "405.742.2696",
        email: "Zack.Laird@flywheelenergy.com",
        relationship:
          "As a contractor for Flywheel Energy, LLC, I collaborated with Zack, who served as the product engineer for the app development team. Together, we worked on various aspects of the app development process, including wireframing, design, and full development.",
      },
      {
        name: "Joe Hischer",
        referenceJob: "Product Engineer",
        company: "iFit",
        phone: "435-938-8580",
        email: "joehischer@gmail.com",
        relationship:
          "During my five years at iFit, I worked closely with Joe, who served as a product engineer for our team from 2019 to 2022. Together, we successfully rebuilt the iFit marketing website, migrated client onboarding apps to new technology, and optimized all iFit products to meet ADA/WCAG compliance standards.",
      },
      {
        name: "Jason Thornhill",
        referenceJob: "Sr. App Developer",
        company: "The State of Oklahoma",
        phone: "405.882.8282",
        email: "jasonethornhill@gmail.com",
        relationship:
          "I collaborated with Jason for several years on Farmers Insurance's development team. Since then, we have partnered on various freelance projects, with Jason managing the back-end development and myself handling front-end design and development.",
      },
    ],
  },
];
